export default "__VITE_ASSET__63fdeee8__"